// extracted by mini-css-extract-plugin
var _1 = "style-module__container___XZs00";
var _2 = "style-module__layout___FtEpg";
var _3 = "style-module__pageTitle___sTp5N";
var _4 = "style-module__termsWrapper___glZju";
var _5 = "style-module__termsWrapperHeader___Nc1uC";
var _6 = "style-module__wrapper___n_Tl5";
export { _1 as "container", _2 as "layout", _3 as "pageTitle", _4 as "termsWrapper", _5 as "termsWrapperHeader", _6 as "wrapper" }
